import React, { useState, useEffect } from "react";
import ProfileExample from "../../assets/img/avatar.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import Layout from "../../components/Layout";
import EyeBlock from "../../assets/img/eye_block.svg";
import EyeOpen from "../../assets/img/eye_open.svg";
import { decodeToken, getToken } from "../../config/auth";
import { Success } from "../../components/Alert";
import api from "../../config/api";
import CircleImage from "../../components/Image/CircleImage";
import swal from "sweetalert";
import Logout from "../../assets/img/logout-red.svg";

require("dotenv").config();

function Profile() {
  const [changePasswordLoad, setChangePasswordLoad] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmedNewPassword, setShowConfirmedNewPassword] = useState(false);
  const [regexPassword, setRegexPassword] = useState(false);

  const [user, setUser] = useState({});

  useEffect(() => {
    const { user: session = {} } = decodeToken();
    setUser(session);
  }, []);

  const changeShowNewPassword = (e) => {
    e.preventDefault();
    setShowNewPassword(!showNewPassword);
  };

  const changeConfirmedNewPassword = (e) => {
    e.preventDefault();
    setShowConfirmedNewPassword(!showConfirmedNewPassword);
  };

  const handleChange = (event) => {
    setUser((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };

  const selectImageNewUser = (e) => {
    if ((e !== undefined) & (e !== null)) {
      if (e.target.files && e.target.files[0]) {
        setUser((values) => ({
          ...values,
          avatar: URL.createObjectURL(e.target.files[0]),
        }));
        setUser((values) => ({ ...values, file: e.target.files[0] }));
      }
    }
  };

  const update = async (e) => {
    e.preventDefault();
    try {
      let res = await api.put(`/user/${user._id}`, user);

      if (res.data.success) {
        const dataup = new FormData();
        if ((user.file !== undefined) & (user.file !== null)) {
          dataup.append("file", user.file);
          await api
            .put("/user-avatar", dataup)
            .then((result) => {
              refreshToken();
            })
            .catch((error) => {
              console.log(error.message);
            });
        }
        refreshToken();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const cancel = () => {
    const { user: session = {} } = decodeToken();
    setUser(session);
    user.role === "admin" ? (window.location.href = "/dashboard") : (window.location.href = "/dashboard-user");
  };

  const refreshToken = async () => {
    await api.put(`/refresh-user-token/${user._id}`, user).then((resLogin) => {
      if (resLogin.data.success) {
        localStorage.setItem("@Reservei:token", resLogin.data.token);
        document.getElementById("btnCallSuccessUpdate").click();
        document.location.href = "/perfil";
      }
    });
  };

  const changePassword = async (e) => {
    e.preventDefault();
    setChangePasswordLoad(true);
    if (!regexPassword) {
      swal(
        "Erro!",
        "As senhas devem ter no mínimo 8 caracteres contendo uma letra, um número e um caracter especial",
        "error"
      );
      return setChangePasswordLoad(false);
    }
    if (user.newPassword === user.confirmPassword) {
      const token = getToken();
      await api.put("/new-password-dashboard", { password: user.newPassword, token }).then((res) => {
        document.getElementById("btnCallSuccess").click();
        setUser((values) => ({ ...values, newPassword: "" }));
        setUser((values) => ({ ...values, confirmPassword: "" }));
      });
    } else {
      console.log("Senhas não conferem");
    }
    setChangePasswordLoad(false);
  };

  function validarSenha(event) {
    const regex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+={[}\]|\\:;"'<,>.?/-]).{8,}$/;
    let pw = regex.test(event.target.value);
    setRegexPassword(pw);
    if (pw) {
      handleChange(event);
    }
  }

  const logout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  return (
    <>
      <Layout defaultMenu={5} title={"Perfil"} link={user.role === "admin" ? "/dashboard" : "/dashboard-user"}>
        <div className=" container-fluid px-lg-1 pt-3">
          <div className="card-body d-flex align-items-center justify-content-center">
            <div className="col-12 col-lg-5">
              <form name="formmodal" onSubmit={update} novalidate>
                <div className="d-flex flex-column">
                  <div className="col-12 d-flex align-items-center justify-content-center">
                    <div className="d-flex align-items-center justify-content-center position-relative rounded-circle ">
                      <CircleImage url={user.avatar === undefined ? ProfileExample : user.avatar} sizePx={"150px"} />
                      <label
                        htmlFor="file"
                        className="p-2 rounded-circle d-flex align-items-center justify-content-center "
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          right: 0,
                          bottom: "10px",
                          backgroundColor: "#0D80FF",
                        }}
                      >
                        <FontAwesomeIcon color="white" icon={faPencilAlt} />
                        <input
                          type="file"
                          id="file"
                          name="avatar"
                          onChange={(e) => selectImageNewUser(e)}
                          className="d-none"
                        />
                      </label>
                    </div>
                  </div>
                  <div className="col-12 d-flex justify-content-center mt-2">
                    <span className="ff-univanova-bold fz-19">{user.name}</span>
                  </div>
                  <div className="col-12 mb-3 mt-4">
                    <label className="form-label ff-univanova-bold text-cl-arsenic-2 fz-16 mb-1">Nome:</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={user.name}
                      onChange={(event) => handleChange(event)}
                      required
                    />
                  </div>
                  <div className="col-12 mb-3">
                    <label className="form-label ff-univanova-bold text-cl-arsenic-2 fz-16 mb-1">E-mail:</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={user.email}
                      onChange={(event) => handleChange(event)}
                      required
                    />
                  </div>
                  <div className="col-12 d-flex justify-content-end">
                    <button
                      className="a-button ff-univanova-regular fz-15"
                      data-bs-toggle="modal"
                      data-bs-target={"#myModalChangePassword"}
                      type="button"
                    >
                      Resetar Senha
                    </button>
                  </div>

                  <div className="col-12 d-flex justify-content-center mt-5 align-items-center">
                    <div className="d-flex align-items-start ">
                      <div className={`item m-0 w-100`}>
                        <button
                          data-bs-toggle="modal"
                          data-bs-target={"#myModalAlertLogOut"}
                          type="button"
                          style={{ paddingLeft: "0px" }}
                          className="btn t-decoration-none d-flex align-items-center px-3"
                        >
                          <img alt="Logout" src={Logout} className="me-2" />
                          <span style={{ color: "#c03d29" }} className="description fz-14 ff-univanova-medium ">
                            Logout
                          </span>
                        </button>
                      </div>
                    </div>
                    <div className={`ms-auto col-lg-auto d-flex justify-content-end`}>
                      <button
                        type="button"
                        onClick={() => cancel()}
                        className="btn button-white-primary br-6 fz-14 border-auro-metal me-3"
                      >
                        Cancelar
                      </button>
                      <button
                        type="submit"
                        className="w-100 button-add btn bg-gradient-theme-blue text-white fz-14 px-4 py-2 d-flex justify-content-center align-items-center ff-univanova-medium"
                      >
                        Salvar alterações
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Layout>
      <div
        className="modal fade border-0"
        id="myModalChangePassword"
        tabIndex="-1"
        aria-labelledby="myModalChangePasswordLabel"
        aria-hidden="true"
        style={{ borderRadius: "10px" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header border-0 pb-0 p-4">
              <button
                type="button"
                id="btnCloseSingle"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pt-0 px-5">
              <form onSubmit={changePassword}>
                <div className="row">
                  <div className="col-12">
                    <span className="ff-univanova-bold fz-16 text-col-arsenic-2">Senha nova</span>
                    <div className="eye-component d-flex mt-2 mb-16">
                      <input
                        style={{
                          borderTop: "1px solid #E0E0E0",
                          borderLeft: "1px solid #E0E0E0",
                          borderBottom: "1px solid #E0E0E0",
                          borderRight: "0px solid transparent",
                          borderRadius: "5px 0px 0px 5px",
                        }}
                        name="newPassword"
                        value={user.newPassword}
                        onChange={(e) => validarSenha(e)}
                        type={showNewPassword ? "text" : "password"}
                        placeholder="Digite sua nova senha"
                        className="password form-control ff-univanova-regular fz-14 text-cl-auroMetal px-2 w-90"
                        required
                      />
                      <button
                        onClick={(event) => changeShowNewPassword(event)}
                        style={{
                          backgroundColor: "transparent",
                          borderTop: "1px solid #E0E0E0",
                          borderRight: "1px solid #E0E0E0",
                          borderBottom: "1px solid #E0E0E0",
                          borderLeft: "0px solid transparent",
                          borderRadius: "0px 5px 5px 0px",
                        }}
                      >
                        <img
                          alt=""
                          width={"24px"}
                          height={"24px"}
                          className=" w-auto"
                          src={showNewPassword ? EyeOpen : EyeBlock}
                        />
                      </button>
                    </div>
                  </div>
                  <div className="col-12">
                    <span className="ff-univanova-bold fz-16 text-col-arsenic-2">Confirmar nova senha</span>
                    <div className="eye-component d-flex mt-2">
                      <input
                        style={{
                          borderTop: "1px solid #E0E0E0",
                          borderLeft: "1px solid #E0E0E0",
                          borderBottom: "1px solid #E0E0E0",
                          borderRight: "0px solid transparent",
                          borderRadius: "5px 0px 0px 5px",
                        }}
                        name="confirmPassword"
                        onChange={(e) => handleChange(e)}
                        value={user.confirmPassword}
                        type={showConfirmedNewPassword ? "text" : "password"}
                        placeholder="Confime a sua nova senha"
                        className="password form-control ff-univanova-regular fz-14 text-cl-auroMetal px-2 w-90"
                        required
                      />
                      <button
                        onClick={(event) => changeConfirmedNewPassword(event)}
                        style={{
                          backgroundColor: "transparent",
                          borderTop: "1px solid #E0E0E0",
                          borderRight: "1px solid #E0E0E0",
                          borderBottom: "1px solid #E0E0E0",
                          borderLeft: "0px solid transparent",
                          borderRadius: "0px 5px 5px 0px",
                        }}
                      >
                        <img
                          alt=""
                          width={"24px"}
                          height={"24px"}
                          className=" w-auto"
                          src={showConfirmedNewPassword ? EyeOpen : EyeBlock}
                        />
                      </button>
                    </div>
                  </div>
                  <div className="row my-3 mx-0">
                    <div className="col-12 d-flex align-items-center justify-content-end px-0">
                      <button
                        type="button"
                        className="btn br-6 button-white-primary border-auro-metal fz-16 me-3 px-4"
                        data-bs-dismiss="modal"
                      >
                        Cancelar
                      </button>
                      {changePasswordLoad ? (
                        <button type="button" className="btn bg-gradient-theme-blue text-white px-4" disabled>
                          <div className="spinner-border spinner-border-sm text-light" role="status">
                            <span className="visually-hidden">Carregando...</span>
                          </div>
                        </button>
                      ) : (
                        <button type="submit" className="btn bg-gradient-theme-blue text-white px-4">
                          Alterar
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <button id="btnCallSuccess" className="d-none" data-bs-toggle="modal" data-bs-target="#NewPassword">
        Chamar modal success
      </button>
      <Success
        id="NewPassword"
        title={"Alteração realizada com sucesso!"}
        description="foi feita a alteração da sua senha"
      />
      <button id="btnCallSuccessUpdate" className="d-none" data-bs-toggle="modal" data-bs-target="#UpdateInfos">
        Chamar modal success
      </button>
      <Success id="UpdateInfos" title={"Alterações realizadas com sucesso!"} description="" />
      <div
        className="modal fade border-0"
        id="myModalAlertLogOut"
        tabIndex="-1"
        aria-labelledby="myModalAlertLogOutLabel"
        aria-hidden="true"
        style={{ borderRadius: "10px" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header border-0 pb-0 p-4">
              <button
                type="button"
                id="btnCloseSingle"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="d-flex flex-column modal-body pt-0 px-5 pb-4">
              <span style={{ textAlign: "center" }} className="text-cl-black ff-univanova-bold fz-24">
                Você tem certeza que quer sair?
              </span>
              <span style={{ textAlign: "center" }} className="mt-3 d-flex text-cl-black ff-univanova-regular fz-14">
                Para retornar ao DASHBOARD, você precisará refazer o Login!
              </span>
              <div className="row my-3 mx-0">
                <div className="col-12 d-flex align-items-center justify-content-center px-0 mt-3">
                  <button
                    type="button"
                    className="btn br-6 button-white-primary border-auro-metal fz-16 me-3 px-4"
                    data-bs-dismiss="modal"
                  >
                    Voltar
                  </button>
                  <button type="submit" onClick={() => logout()} className="btn bg-gradient-theme-blue text-white px-4">
                    Sair do sistema
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Profile;
